import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";
import { BundledProductsModel } from "@NA/Services/ADIBundledProductsService";
import BundledProductsState from "../Data/ADIBundledProductsState";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

const initialState: BundledProductsState = {
    isLoading: false,
    bundledProductsById: {},
    errorMessageById: {},
};

const reducer = {
    "Custom/DispatchLoadBundledProducts": (
        draft: Draft<BundledProductsState>,
        action: { result: BundledProductsModel },
    ) => {
        draft.isLoading = true;
    },
    "Custom/DispatchCompleteLoadBundledProducts": (
        draft: Draft<BundledProductsState>,
        action: { products: ProductModel[]; id: string; errorMessage?: string },
    ) => {
        const bundledProductByProductId: ProductModel[] = [];
        for (const product of action.products) {
            //product.productTitle = product.shortDescription ?? "";
            bundledProductByProductId.push(product);
        }
        bundledProductByProductId.sort((a,b)=> {
            return a.productNumber < b.productNumber ? -1 : 1;
        })

        draft.bundledProductsById[action.id] = {
            bundledProductByProductId,
        };
        draft.errorMessageById[action.id] = action.errorMessage;
        draft.isLoading = false;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
